export var getStyles = function (props) {
    var theme = props.theme, className = props.className, enableShimmer = props.enableShimmer;
    var semanticColors = theme.semanticColors, palette = theme.palette;
    var overlayStyles = {
        // set `position: relative` to stop the fading overlay cover the DetailsList header.
        position: 'relative',
        selectors: {
            ':after': {
                content: '""',
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundImage: "linear-gradient(to bottom,\n                          transparent 30%,\n                          " + palette.whiteTranslucent40 + " 65%,\n                          " + semanticColors.listBackground + " 100%)"
            }
        }
    };
    return {
        root: [enableShimmer && overlayStyles, className]
    };
};
//# sourceMappingURL=ShimmeredDetailsList.styles.js.map